<template>
  <div>
    <Menu />

    <section class="uk-section-muted">
      <div
        uk-img
        class="uk-background-norepeat uk-background-cover uk-background-center-center uk-section uk-section-medium"
        style="background-image: url('https://images.pexels.com/photos/1433271/pexels-photo-1433271.jpeg');"
      >
        <div class="uk-container">
          <div class="uk-grid-margin uk-grid uk-grid-stack" uk-grid>
            <div class="uk-flex-auto uk-width-1-1@m uk-first-column">
              <h1 class="uk-h1 uk-width-xlarge dark">
                Contact us
              </h1>
              <h2 class="uk-text-lead uk-width-xlarge">
                Lorem ipsum dolor sit amet.
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="uk-section-default uk-section uk-section-large">
      <div class="uk-container">
        <div class="uk-grid-margin uk-grid uk-grid-stack" uk-grid>
          <div class="uk-width-1-1@m uk-first-column">
            <h2 class="uk-width-xxlarge uk-margin-auto uk-text-center">
              IMAGES
            </h2>
          </div>
        </div>
      </div>
    </section>

    <section class="uk-section-secondary">
      <div
        data-src="https://images.pexels.com/photos/3298635/pexels-photo-3298635.jpeg"
        data-sizes="(max-aspect-ratio: 2560/943) 271vh"
        uk-img
        class="uk-background-norepeat uk-background-cover uk-background-center-center uk-section uk-section-large"
      >
        <div class="uk-container">
          <div class="uk-grid-margin uk-grid uk-grid-stack" uk-grid>
            <div class="uk-width-1-1@m uk-first-column">
              <h3
                class="uk-h2 uk-margin-medium uk-width-large uk-margin-auto uk-text-center"
              >
                Every project is a new challenge to produce something unique.
              </h3>
              <div class="uk-margin uk-text-center">
                <a class="uk-button uk-button-text" title="Learn more" href="#"
                  >Learn more</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script>
import Menu from "./Menu";
import Footer from "./Footer";

export default {
  name: "Main",
  components: {
    Menu,
    Footer
  },
  mounted() {
    //
  }
};
</script>
